import type { Novidade } from './tipos';

/** Fase 2 (W11): assistentes pessoais com níveis de risco e aprovação por passkey. */
export const novidadeAssistentes: Novidade = {
  id: '2026-10-05-assistentes',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'Seu assistente de IA, com a sua confirmação',
      resumo: 'O assistente trabalha em seu nome: faz direto o que é reversível e pede a sua confirmação, com a biometria do celular, no que é sensível.',
      passos: [
        'Em Minha conta, Meus assistentes, crie o assistente e escolha os módulos e os limites.',
        'Em Minha conta, Segurança, crie uma passkey: o celular confirma com Face ID, Touch ID ou digital.',
        'Quando o assistente preparar uma exclusão ou uma ação com dinheiro, o aviso chega no sino e no celular.',
        'Na tela Aprovar ação, confira o resumo e aprove com a passkey ou recuse.',
      ],
    },
    en: {
      titulo: 'Your AI assistant, with your confirmation',
      resumo: 'It works on your behalf: does reversible actions directly and asks for your confirmation, with phone biometrics, on sensitive ones.',
      passos: [
        'In My account, My assistants, create the assistant and choose the modules and the limits.',
        'In My account, Security, create a passkey: your phone confirms with Face ID, Touch ID or fingerprint.',
        'When the assistant prepares a deletion or an action with money, the notice reaches the bell and your phone.',
        'On the Approve action screen, check the summary and approve with your passkey or decline.',
      ],
    },
    es: {
      titulo: 'Tu asistente de IA, con tu confirmación',
      resumo: 'Trabaja en tu nombre: hace directo lo reversible y pide tu confirmación, con la biometría del celular, en lo sensible.',
      passos: [
        'En Mi cuenta, Mis asistentes, crea el asistente y elige los módulos y los límites.',
        'En Mi cuenta, Seguridad, crea una passkey: el celular confirma con Face ID, Touch ID o huella.',
        'Cuando el asistente prepare una eliminación o una acción con dinero, el aviso llega a la campana y al celular.',
        'En la pantalla Aprobar acción, revisa el resumen y aprueba con la passkey o rechaza.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-assistentes/meus-assistentes.webp', null, null, '/novidades/2026-10-05-assistentes/aprovar.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/conta/assistentes',
};
